var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMonitorAlt3SvgrepoCom1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "monitor-alt-3-svgrepo-com 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.58333 22.75H18.4167M6.71667 18.4167H19.2833C20.4968 18.4167 21.1036 18.4167 21.567 18.1805C21.9747 17.9728 22.3062 17.6413 22.5138 17.2337C22.75 16.7702 22.75 16.1634 22.75 14.95V6.71667C22.75 5.50322 22.75 4.89649 22.5138 4.43302C22.3062 4.02533 21.9747 3.69387 21.567 3.48616C21.1036 3.25 20.4968 3.25 19.2833 3.25H6.71667C5.50322 3.25 4.89649 3.25 4.43302 3.48616C4.02533 3.69387 3.69387 4.02533 3.48616 4.43302C3.25 4.89649 3.25 5.50321 3.25 6.71667V14.95C3.25 16.1634 3.25 16.7702 3.48616 17.2337C3.69387 17.6413 4.02533 17.9728 4.43302 18.1805C4.89649 18.4167 5.50321 18.4167 6.71667 18.4167Z",
    stroke: "#A60FB3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitorAlt3SvgrepoCom1);
export default __webpack_public_path__ + "static/media/monitor-alt-3-svgrepo-com 1.9c04ea5c0f566fdf6fb54d0399cc1940.svg";
export { ForwardRef as ReactComponent };